import { CommonModule } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HeaderComponent as GbHeaderComponent } from '@bookinglab/govbook-ui/layout';
import {
  ImageDetail,
  NavLink,
} from '@bookinglab/govbook-ui/layout/lib/util/model';
@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	standalone: true,
	imports: [CommonModule, GbHeaderComponent, MatIconModule],
})
export class HeaderComponent {
	goToWebsite() {
		window.open('https://www.cambridgeshire.gov.uk/', '_blank', 'noopener,noreferrer');
	}

	imageDetail: ImageDetail = {
		alt: 'Cambridgeshire County Council',
		src: 'assets/images/cambridgeshirecc-logo.svg',
		href: 'https://www.cambridgeshire.gov.uk/',
	};

	navigation: NavLink[] = [
		{
			text: 'Births, deaths and marriages',
			url: 'https://www.cambridgeshire.gov.uk/residents/births-deaths-and-marriages',
		},
		{
			text: 'Ceremonies',
			url: 'https://www.cambridgeshire.gov.uk/residents/births-deaths-and-marriages/ceremonies',
		},
		{
			text: 'Registration offices',
			url: 'https://www.cambridgeshire.gov.uk/residents/births-deaths-and-marriages/registration-offices',
		},
		{
			text: 'Fees',
			url: 'https://www.cambridgeshire.gov.uk/residents/births-deaths-and-marriages/table-of-fees',
		},
		{
			text: 'Contact us',
			url: 'https://www.cambridgeshire.gov.uk/council/contact-us',
		},
	];

	search(term: string) {
		const formatted = encodeURIComponent(term.trim());
		const url = `https://www.cambridgeshire.gov.uk/search?searchtext=${formatted}`;
		window.location.href = url;
	}
}
